import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

export function gameCategories(state: any[] = [], action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_CATEGORIES_SUCCESS:
            return action.payload.categories.results;

        default:
            return state;
    }
}

export function gameCategoriesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_CATEGORIES:
        case GamesActionTypes.SAVE_GAME_CATEGORY:
        case GamesActionTypes.DELETE_GAME_CATEGORY:
            return true;

        case GamesActionTypes.GET_GAME_CATEGORIES_SUCCESS:
        case GamesActionTypes.GET_GAME_CATEGORIES_FAIL:
        case GamesActionTypes.SAVE_GAME_CATEGORY_FAIL:
        case GamesActionTypes.DELETE_GAME_CATEGORY_FAIL:
            return false;

        default:
            return state;
    }
}
